/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".fx-modal-content[_ngcontent-%COMP%]{padding-left:16px;font-size:16px}.toolbar[_ngcontent-%COMP%]{height:100%;display:flex;flex-flow:column;align-content:center;justify-content:center}.my-tree[_ngcontent-%COMP%]{background:#fff;border:1px solid #bdc3c7;margin-top:20px;height:450px}"];
export { styles as styles };
